import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function ScrollToTop() {
  const { pathname, state } = useLocation();

  useEffect(() => {
    // Skip when navigation explicitly opts out (e.g. ASL/LSQ language toggle)
    if (state && state.preserveScroll) return;
    window.scrollTo(0, 0);
  }, [pathname, state]);

  return null;
}

export default ScrollToTop;
